import {AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MD_DIALOG_DATA, MdDialogRef} from '@angular/material';
import {
  FilterType, GenFilterAcopio, GenFilterCliente,
  GenFilterColaborador,
  GenFilterFechaFromTo,
  GenFilterNumberFromTo,
  GenFilterSelect,
  GenFilterTypes, NC
} from '../../negocio-filter';
import {from} from 'rxjs/observable/from';
import * as moment from 'moment';
import {AcopioViewModel, ClienteViewModel, MercadoViewModel, ProductoViewModel, UserViewModel} from '@utils/ViewModels';
import {ColaboradorAutocompleteComponent, CuentaAutocompleteComponent} from '@common/autocomplete';
import {FUENTE_NAMES, NegociosService} from '@services/negocios-service';
import {ProductoOption, ProductoService} from '@services/producto-service';
import {Subject} from 'rxjs/Subject';
import {CategoriaService, CategoriaZona} from '@services/categoria-service';
import {Moneda, MONEDA_PESIFICACION, MonedaService} from '@services/moneda-service';
import {PreciosService} from '@services/precios-service';
import {Cosecha, CosechaService} from '@services/cosecha-service';
import {EntregaService} from '@services/entrega-service';

@Component({
  selector: 'app-neg-new-filters-dialog',
  templateUrl: './neg-new-filters-dialog.component.html',
  styleUrls: ['./neg-new-filters-dialog.component.scss']
})
export class NegNewFiltersDialogComponent implements AfterViewInit, OnDestroy {

  readonly F_TYPE = FilterType;

  // number
  numberFrom = 0;
  numberTo = 0;

  dateFrom: Date = moment().subtract(30, 'day').toDate();
  dateTo: Date = new Date();

  acopios: AcopioViewModel[] = [];

  tmpSelect: GenFilterSelect | null | undefined = null;
  tmpSingleSelect: number | string | null | undefined = null
  selectOptionsInitial: GenFilterSelect[] = [];
  selectOptions: GenFilterSelect[] = [];
  selectedOptions: GenFilterSelect[] = [];
  tmpAutorizante = -2;
  @ViewChild(ColaboradorAutocompleteComponent) colabAutocomplete: ColaboradorAutocompleteComponent;
  @ViewChild(CuentaAutocompleteComponent) clienteAutocomplete: CuentaAutocompleteComponent;

  single = false;
  destroyedSubject = new Subject<void>();
  autorizanteData: GenFilterColaborador[] = [];

  constructor(
    @Inject(MD_DIALOG_DATA) public data: NegNewFiltersDialogData,
    private dialogRef: MdDialogRef<NegNewFiltersDialogComponent>,
    private negociosService: NegociosService,
    private productoService: ProductoService,
    private zonaService: CategoriaService,
    private monedaService: MonedaService,
    private preciosService: PreciosService,
    private cosechaService: CosechaService,
    private entregaService: EntregaService,
  ) {
    this.single = [NC.producto.name, NC.negocio.name, NC.entrega.name, NC.cosecha.name, NC.moneda.name,
      NC.match.name, NC.autorizante.name, NC.mercado.name, NC.fuente.name].includes(data.column)
    // aqui vamos a cargar las opciones
    if (this.data.column === NC.confirmacion.name) {
      const confOpts = this.negociosService.getConfirmacionOptions().map(x => {
        return { Id: x.ID, displayValue: x.Value, rawValue: JSON.stringify(x) };
      });
      this.setSelectOptions(confOpts);
    } else if (this.data.column === NC.tipo.name) {
      const tipoOpts = this.negociosService.getTipoSelectOptions().map(x => {
        return { Id: x.ID, displayValue: x.Tipo_Negocio, rawValue: JSON.stringify(x) };
      });
      this.setSelectOptions(tipoOpts);
    } else if (this.data.column === NC.producto.name) {
      productoService.Options.takeUntil(this.destroyedSubject).subscribe(newValue => {
        const prodOpts = (newValue as ProductoOption[]).map(x => {
          return { Id: x.ID, displayValue: x.Producto, rawValue: JSON.stringify(x) };
        });
        this.setSelectOptions(prodOpts)
      });
    } else if (this.data.column === NC.negocio.name) {
      const negOpts = this.negociosService.getNegocioSelectOptions().slice(0, 3).map(x => {
        return { Id: x.value, displayValue: x.label, rawValue: JSON.stringify(x) };
      });
      this.setSelectOptions(negOpts)

    } else if (this.data.column === NC.entrega.name) {
      entregaService.PosicionOptions.takeUntil(this.destroyedSubject).subscribe(newValue => {
        const entregaOpts = newValue.map((x, i) => {
          return { Id: i, displayValue: (x.Entrega || x.Posicion), rawValue: JSON.stringify(x) };
        });
        this.setSelectOptions(entregaOpts);
      });

    } else if (this.data.column === NC.cosecha.name) {
      cosechaService.Options.takeUntil(this.destroyedSubject).subscribe(newValue => {
        const cosechasOpts = (newValue as Cosecha[]).sort(function (a, b) { return b.Desde - a.Desde }).map(x => {
          return { Id: x.ID, displayValue: x.Cosecha, rawValue: JSON.stringify(x) };
        });
        this.setSelectOptions(cosechasOpts);
      });

    } else if (this.data.column === NC.moneda.name) {
      monedaService.Options.takeUntil(this.destroyedSubject).subscribe(newValue => {
        const monedaOpts = ([...newValue || [], MONEDA_PESIFICACION] as Moneda[]).map(x => {
          return { Id: x.ID, displayValue: `${x.Moneda} ${x.Simbolo}`, rawValue: JSON.stringify(x) };
        });
        this.setSelectOptions(monedaOpts);
      });

    } else if (this.data.column === NC.match.name) {
      this.setSelectOptions([
        {Id: 1, displayValue: 'Sí', rawValue: JSON.stringify(true)},
        {Id: 0, displayValue: 'No', rawValue: JSON.stringify(true)}
      ]);

    } else if (this.data.column === NC.autorizante.name) {
      this.setSelectOptions([
        {Id: 1, displayValue: 'Automático', rawValue: JSON.stringify('AUTO')},
        {Id: 0, displayValue: 'No Automático', rawValue: JSON.stringify('NO-AUTO')}
      ]);

    } else if (this.data.column === NC.zona.name) {
      zonaService.Options.takeUntil(this.destroyedSubject).subscribe(newValue => {
        const zonaOpts = (newValue as CategoriaZona[]).map(x => {
          return { Id: x.ID, displayValue: x.Categoria, rawValue: JSON.stringify(x) };
        })
        this.setSelectOptions(zonaOpts);
      });

    } else if (this.data.column === NC.mercado.name) {
      this.preciosService.getMercadosPizarra().take(1).subscribe(x => {
        const mercOpts = (x as MercadoViewModel[]).map(x => {
          return { Id: x.Id, displayValue: x.Mercado, rawValue: JSON.stringify(x) };
        })
        this.setSelectOptions(mercOpts);
      });

    } else if (this.data.column === NC.fuente.name) {
      this.setSelectOptions(
        FUENTE_NAMES.map((x, i) => {
          return { Id: i+1, displayValue: x, rawValue: JSON.stringify(i+1) };
        })
      )
    }
  }

  ngAfterViewInit() {
    if (this.data.data !== null) {
      switch (this.data.type) {
        case FilterType.NumberFromTo:
          this.numberFrom = (this.data.data as GenFilterNumberFromTo).From
          this.numberTo = (this.data.data as GenFilterNumberFromTo).To
          break;
        case FilterType.FechaFromTo:
          this.dateFrom = (this.data.data as GenFilterFechaFromTo).from
          this.dateTo = (this.data.data as GenFilterFechaFromTo).to
          break;
        case FilterType.Acopio:
          this.acopios = (this.data.data as GenFilterAcopio[]).map(x => x.data);
          break;
        case FilterType.Colaborador:
          this.colabAutocomplete.selectedColaboradores = (this.data.data as GenFilterColaborador[]).map(x => x.data);
          break;
        case FilterType.Cliente:
          this.clienteAutocomplete.selectedCuentas = (this.data.data as GenFilterCliente[]).map(x => x.data);
          break;
        case FilterType.Select:
          if (this.single) {
            this.tmpSingleSelect = (this.data.data as GenFilterSelect).Id;
          } else {
            this.selectedOptions = this.data.data as GenFilterSelect[];
          }
          this.verifySelectedOptionsIntegrity();
          break;
        case FilterType.Autorizante:
          const data = (this.data.data as GenFilterColaborador[]);
          if (data.length && data[0].Id === 0) {
            this.tmpAutorizante = 0;
          } else {
            this.autorizanteData = data;
            this.tmpAutorizante = -1;
          }
          break;
      }
    }
  }

  initializeAutorizante() {
    this.colabAutocomplete.selectedColaboradores = this.autorizanteData.map(x => x.data);
  }

  ngOnDestroy() { this.destroyedSubject.next() }

  selectedStartDate(e: Date) {
    if (e > this.dateTo) {
      this.dateTo = e;
    }
  }
  selectedEndDate(e: Date) {
    if (e < this.dateFrom) {
      this.dateFrom = e;
    }
  }

  setSelectOptions(options: GenFilterSelect[]) {
    this.selectOptionsInitial = options.map(x => x);
    this.selectOptions = options.map(x => x);
    this.verifySelectedOptionsIntegrity();
  }

  // Aqui verificamos si hay opciones seleccionadas, para quitarlas de la lista de opciones a seleccionar
  verifySelectedOptionsIntegrity() {
    if (this.selectedOptions.length) {
      // si tenemos algo seleccionado, quitamos las opciones seleccionadas
      this.selectedOptions.forEach(selectedOption => {
        this.selectOptions = this.selectOptions.filter(baseOption => baseOption.Id !== selectedOption.Id)
      })
    }
  }

  changeSingleSelect() {
    if (this.tmpSingleSelect === undefined) {
      this.tmpSingleSelect = null;
      this.onSubmit();
      return;
    }
    this.onSubmit();
  }

  changeSelect() {
    // Opción "Todas"
    if (this.tmpSelect === undefined) {
      this.tmpSelect = null;
      this.selectedOptions = [];
      this.onSubmit();
      return;
    }
    this.selectedOptions.push(this.selectOptions.find(o => o.Id === this.tmpSelect.Id));
    this.selectOptions = this.selectOptions.filter(o => o.Id !== this.tmpSelect.Id);
    this.tmpSelect = null;
  }


  removeSelect(item: GenFilterSelect) {
    this.selectedOptions = this.selectedOptions.filter(o => o.Id !== item.Id);
    this.selectOptions.push(item);
    this.selectOptions.sort((a, b) => (a.Id as any) - (b.Id as any));
    this.tmpSelect = null;
  }


  onSubmit() {
    switch (this.data.type) {
      case FilterType.NumberFromTo:
        const resNumber: GenFilterNumberFromTo = {
          From: this.numberFrom,
          To: this.numberTo
        };
        this.dialogRef.close(this.getReturnData(resNumber));
        break;

      case FilterType.FechaFromTo:
        const resFecha: GenFilterFechaFromTo = {
          from: this.dateFrom,
          to: this.dateTo
        };
        this.dialogRef.close(this.getReturnData(resFecha));
        break;

      case FilterType.Colaborador:
        const selectedColabs: GenFilterColaborador[] = this.colabAutocomplete.selectedColaboradores.map(x => {
          const colab = x as UserViewModel;
          return {
            Id: colab.UserId,
            displayValue: colab.UserFullName,
            data: colab,
          }
        })
        this.dialogRef.close(this.getReturnData(selectedColabs.length ? selectedColabs : null));
        break;

      case FilterType.Acopio:
        const selectedAcopios: GenFilterAcopio[] = this.acopios.map(x => {
          return {
            displayValue: x.AcopioNombre,
            Id: x.Id,
            data: x,
          }
        })
        this.dialogRef.close(this.getReturnData(selectedAcopios.length ? selectedAcopios : null));
        break;

      case FilterType.Cliente:
        const selectedclientes: GenFilterCliente[] = this.clienteAutocomplete.selectedCuentas.map(x => {
          const cli = x as ClienteViewModel;
          return {
            Id: cli.Id,
            displayValue: cli.FullName,
            data: cli,
          }
        })
        this.dialogRef.close(this.getReturnData(selectedclientes.length ? selectedclientes : null));
        break;

      case FilterType.Select:
        if (this.single) {
          this.dialogRef.close(
            this.getReturnData(
              this.tmpSingleSelect !== null && this.tmpSingleSelect !== undefined ? this.selectOptionsInitial.find(x => x.Id === this.tmpSingleSelect) : null
            )
          );
        } else {
          this.dialogRef.close(this.getReturnData(this.selectedOptions.length ? this.selectedOptions : null));
        }
        break;

      case FilterType.Autorizante:
        if (this.tmpAutorizante !== null) {
          // usuario seleccionado
          if (this.tmpAutorizante === -1) {
            const selectedColabs: GenFilterColaborador[] = this.colabAutocomplete.selectedColaboradores.map(x => {
              const colab = x as UserViewModel;
              return {
                Id: colab.UserId,
                displayValue: colab.UserFullName,
                data: colab,
              }
            })
            this.dialogRef.close(this.getReturnData(selectedColabs.length ? selectedColabs : null));
          } else {
            // automatico
            this.dialogRef.close(this.getReturnData([{
              Id: 0,
              displayValue: 'Automático',
              data: null,
            }]));
          }
        }
        return this.getReturnData(null);

      default:
        this.dialogRef.close(null);
        break;
    }
  }

  getReturnData(res: GenFilterTypes): NegNewFiltersDialogData {
    return {
      column: this.data.column,
      data: res,
      type: this.data.type
    }
  }

  protected readonly from = from;
}

export interface NegNewFiltersDialogData {
  column: string,
  type: FilterType,
  data: GenFilterTypes,
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/negocios/negocio-list/neg-new-filters-dialog/neg-new-filters-dialog.component.ts